import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Icon,
  Paper,
  Stack,
  Toolbar,
  Typography
} from "@mui/material";
import { useState } from "react";
import Header from "../components/header/Header";
import { login, logout, revalidarAcesso } from "../shared/keycloak";
import useSessao from "../shared/useSessao";

export default function AcessoAplicacao({ children }) {
  const sessao = useSessao();
  const [verificando, setVerificando] = useState(false);
  const [aviso, setAviso] = useState("");
  if (sessao.hasAccess) return children;
  const semConfiguracao = !sessao.authRequired;
  const expirou = !semConfiguracao && !sessao.authenticated;
  const titulo = semConfiguracao
    ? "Acesso indisponível"
    : expirou
    ? "Sua sessão expirou"
    : "Acesso não autorizado";
  async function verificar() {
    setVerificando(true);
    setAviso("");
    try {
      await revalidarAcesso();
      setAviso(
        "Permissão consultada. Se o acesso continuar bloqueado, solicite a liberação ao responsável pelo sistema."
      );
    } catch (_) {
      setAviso(
        "Não foi possível atualizar sua sessão. Entre novamente para continuar."
      );
    } finally {
      setVerificando(false);
    }
  }
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <Header />
      <Toolbar sx={{ minHeight: { xs: 112, sm: 72 } }} />
      <Container component="main" maxWidth="sm" sx={{ py: { xs: 4, sm: 9 } }}>
        <Paper variant="outlined" sx={{ p: { xs: 3, sm: 5 }, borderRadius: 2 }}>
          <Box
            sx={{
              bgcolor: "action.hover",
              borderRadius: "50%",
              width: 64,
              height: 64,
              display: "grid",
              placeItems: "center",
              mb: 3
            }}
          >
            <Icon sx={{ fontSize: 32, color: "text.secondary" }}>
              {expirou ? "schedule" : "lock_outline"}
            </Icon>
          </Box>
          <Typography
            component="h1"
            variant="h4"
            sx={{ fontWeight: 600, fontSize: { xs: 26, sm: 30 }, mb: 2 }}
          >
            {titulo}
          </Typography>
          <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
            {semConfiguracao
              ? "O login desta aplicação ainda não foi configurado. Contate o suporte para habilitar o acesso."
              : expirou
              ? "Entre novamente para continuar usando o eSocial com segurança."
              : "Sua conta está autenticada, mas ainda não tem permissão para acessar as operações do eSocial neste ambiente."}
          </Typography>
          {!semConfiguracao && !expirou && (
            <Typography color="text.secondary" sx={{ mt: 2, lineHeight: 1.7 }}>
              Solicite a liberação ao responsável pelo sistema, informando o
              usuário e o ambiente exibidos acima. Depois, verifique o acesso
              novamente.
            </Typography>
          )}
          {aviso && (
            <Alert severity="info" sx={{ mt: 3 }}>
              {aviso}
            </Alert>
          )}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            sx={{ mt: 4 }}
          >
            {semConfiguracao ? (
              <Button
                variant="contained"
                disableElevation
                onClick={() => window.location.reload()}
              >
                Tentar novamente
              </Button>
            ) : expirou ? (
              <Button
                variant="contained"
                disableElevation
                onClick={() => login()}
              >
                Entrar novamente
              </Button>
            ) : (
              <Button
                variant="contained"
                disableElevation
                onClick={verificar}
                disabled={verificando}
                startIcon={
                  verificando ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <Icon>refresh</Icon>
                  )
                }
              >
                Verificar acesso
              </Button>
            )}
            {!semConfiguracao && (
              <Button
                variant="outlined"
                onClick={() => logout()}
                disabled={verificando}
                startIcon={<Icon>logout</Icon>}
              >
                Sair da conta
              </Button>
            )}
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}
